<template>
    <nav class="navbar navbar-default navbar-fixed-top navbar-inverse">
        <div class="nav-container">
            <div class="container-fluid">
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                    <router-link :to="{ path: '/' }" class="navbar-brand">
                        <img src="../../assets/images/logo@2x.png" srcset="../../assets/images/logo@2x.png 1200w, ../../assets/images/logo@3x.png 800w" alt="logo">
                    </router-link>
                </div>
                <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                    <ul class="nav navbar-nav navbar-container">
                        <li class="index-page-btn"><router-link :to="{ path: '/' }">首页</router-link></li>
                        <li><router-link :to="{ path: '/intro' }">公司简介 <span class="sr-only">(current)</span></router-link></li>
                        <li><router-link :to="{ path: '/products' }">核心产品</router-link></li>
                        <li><router-link :to="{ path: '/resource' }">核心资源</router-link></li>
                        <li><router-link :to="{ path: '/mall' }">文创商城</router-link></li>
                        <li><router-link :to="{ path: '/news' }">新闻动态</router-link></li>
                        <li><router-link :to="{ path: '/contact' }">联系我们</router-link></li>
                    </ul>
                    <ul class="nav navbar-nav navbar-icons-container">
                        <li class="wechat-code-wrapper">
                            <img src="../../assets/images/icon_wechat@2x.png" srcset="../../assets/images/icon_wechat@2x.png 1200w, ../../assets/images/icon_wechat@3x.png 800w" class="icon-top  icon-wechat" alt="icon_wechat">
                            <div class="icon-code-wrapper icon-wechat-code-wrapper">
                                <img src="../../assets/images/wechat_code@2x.png" class="wechat-code" alt="微信" />
                            </div>
                        </li>
                        <li class="sina-code-wrapper">
                            <img src="../../assets/images/icon_sina@2x.png" srcset="../../assets/images/icon_sina@2x.png 1200w, ../../assets/images/icon_sina@3x.png 800w" class="icon-top icon-sina" alt="icon_sina">
                            <div class="icon-code-wrapper icon-sina-code-wrapper">
                                <img src="../../assets/images/sina_code@2x.png" class="sina-code" alt="微博" />
                            </div>
                        </li>
                        <li class="tiktok-code-wrapper">
                            <img src="../../assets/images/icon_tiktok@2x.png" srcset="../../assets/images/icon_tiktok@2x.png 1200w, ../../assets/images/icon_tiktok@3x.png 800w" class="icon-top icon-tiktok" alt="icon_tiktok">
                            <div class="icon-code-wrapper icon-tiktok-code-wrapper">
                                <img src="../../assets/images/tiktok_code@3x.png" class="tiktok-code" alt="抖音" />
                            </div>
                        </li>
                    </ul>

                </div>
            </div>
        </div>
    </nav>
</template>
<script>
export default {
    name: 'Header',
    watch: {
        '$route': 'getPath'
    },
    methods: {
        getPath() {
            let screenWidth = document.body.clientWidth
            if ( screenWidth <= 768 ) {
                $('.navbar-collapse').removeClass('in')
            }
        }
    }
}
</script>
<style lang="scss"  scoped>
    .navbar {
        height: 80px;
        background-color: #000000;
        border-bottom: none;
        margin-bottom: 0;
        .navbar-brand {
            width: 135px;
            height: 46px;
            padding: 0;
            margin-top: 18px;
            img {
                width: 100%;
            }
        }
        .navbar-nav li.active a, 
        .navbar-nav li.active a:hover {
            background: none;
        }
    }
    
    
    @media screen and (min-width: 768px){
        .navbar {
            background: rgba(0, 0, 0, 0.44);
            .nav-container {
                width: 1277px;
                height: 80px;
                margin: 0 auto;
                .container-fluid {
                    padding: 0;
                    .navbar-header {
                        // margin-right: 489px;
                        margin-right: 378px;
                    }
                    .navbar-container {
                        width: 603px;
                        height: 30px;
                        margin-top: 25px;
                        padding: 0 11px;
                        border-right: 1px solid rgba(255, 255, 255, 0.15);
                        box-sizing: border-box;
                        li {
                            width: 56px;
                            height: 30px;
                            margin-right: 36px;
                            &:first-of-type {
                                width: 28px;
                            }
                            &:last-of-type {
                                margin-right: 0;
                            }
                            &.active {
                                a {
                                    color: #fff8ec;
                                }
                            }
                            a {
                                width: 56px;
                                height: 30px;
                                line-height: 30px;
                                font-family: CTLaoSongSJ;
                                font-size: 14px;
                                color: #fff8ec;
                                padding: 0;
                            }
                        }
                    }
                    .navbar-icons-container {
                        width: 111px;
                        height: 30px;
                        margin-top: 25px;
                        padding: 5px 0 0 12px;
                        box-sizing: border-box;
                        li {
                            position: relative;
                            padding: 0;
                            .icon-top {
                                cursor: pointer;
                                &.icon-wechat {
                                    width: 25px;
                                    height: 22px;
                                    margin-right: 13px;
                                }
                                &.icon-sina {
                                    width: 26px;
                                    height: 22px;
                                    margin-right: 16px;
                                }
                                &.icon-tiktok {
                                    width: 19px;
                                    height: 22px;
                                }
                            }
                            .icon-code-wrapper {
                                position: absolute;
                                top: 30px;
                                left: 0;
                                opacity: 0;
                                transition: all .5s;
                                -webkit-transition: all .5s;
                                .wechat-code {
                                    width: 75px;
                                    height: 76px;
                                }
                                .sina-code {
                                    width: 77px;
                                    height: 76px;
                                }
                                .tiktok-code {
                                    width: 81px;
                                    height: 76px;
                                }
                            }
                            &.wechat-code-wrapper {
                                &:hover {
                                    .icon-wechat-code-wrapper {
                                        opacity: 1;
                                    }
                                }
                            }
                            &.sina-code-wrapper {
                                &:hover {
                                    .icon-sina-code-wrapper {
                                        opacity: 1;
                                    }
                                }
                            }
                             &.tiktok-code-wrapper {
                                &:hover {
                                    .icon-tiktok-code-wrapper {
                                        opacity: 1;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 768px){
        .navbar-header {
            height: 80px;
            .navbar-brand {
                padding-left: 15px;
            }
            .navbar-toggle {
                margin-top: 23px;
            }
        }
        .navbar-collapse {
            background: #000;
            border-top: none;
            max-height: 100%;
            .navbar-nav {
                padding: 0 30px;
                &.navbar-container {
                    margin-bottom: 0;
                }
                li {
                    border-bottom: 1px solid #cacaca;
                    box-sizing: border-box;
                    &.active {
                        a {
                            color: #fff;
                        }
                    } 
                    a {
                        text-align: center;
                        color: #fff;
                    }
                }
                
            }
            .navbar-icons-container {
               display: none;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/layout/components/Header.vue